import { render } from "./EvaluationCommentsDialog.vue?vue&type=template&id=4991ba1b&scoped=true"
import script from "./EvaluationCommentsDialog.vue?vue&type=script&lang=js"
export * from "./EvaluationCommentsDialog.vue?vue&type=script&lang=js"

import "./EvaluationCommentsDialog.vue?vue&type=style&index=0&id=4991ba1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4991ba1b"]])

export default __exports__